export default __webpack_public_path__ + "static/media/search.319b2df3.svg";